import { useMutation } from 'react-query';

import { setCheckMandatorily as mutationFn } from 'api/endPoints/setCheckMandatorily';

export const useMutationSetCheckMandatory = () => {
    return useMutation<
        boolean,
        QueryError,
        {
            checkId: number;
            mandatory: boolean;
            metaDataId: number;
        }
    >((params) => mutationFn(params));
};
